module.exports = __webpack_public_path__ + "static/media/7 28 '02_2ab3d783-cfb4-4be4-9c57-dc87e5b60d92.df56937f.png";